import { render, staticRenderFns } from "./InformerCard.htm?vue&type=template&id=3795505c&scoped=true&"
import script from "./InformerCard.ts?vue&type=script&lang=js&"
export * from "./InformerCard.ts?vue&type=script&lang=js&"
import style0 from "./InformerCard.scss?vue&type=style&index=0&id=3795505c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795505c",
  null
  
)

export default component.exports